import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ClientService {

    constructor(private http: HttpClient) { }

    searchClients(name: string = ''): Observable<any> {
        let params = new HttpParams();
        if (name) {
            params = params.set('name', name);
        }

        return this.http.get(`${environment.api_url}/clients/search`, { params });
    }

    createClient(payload: { businessName: string }): Observable<any> {
        return this.http.post(`${environment.api_url}/clients`, payload);
    }

    updateClient(id: string, payload: { businessName: string; status: string }): Observable<any> {
        return this.http.put(`${environment.api_url}/clients/${id}`, payload);
    }

    deleteClient(id: string): Observable<any> {
        return this.http.delete(`${environment.api_url}/clients/${id}`);
    }
}